import axios from "axios";
import { useNavigate } from "react-router-dom";
import { config, isDevMode } from "./Constants";
import {useDispatch} from "react-redux";
import {resetResponseState} from "../features/responseSlice";
import { attachHttpRecorder } from "../New/utils/httpRecorder";

const URL = config.url;

const useMerchantPortalAxios = () => {

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const MerchantPortalClient = attachHttpRecorder(axios.create({
    baseURL: URL,
    timeout: isDevMode ? 300000 : 15000,
    headers: {
      "Content-Type": "application/json",
      Authorization: sessionStorage.getItem("Token"),
    },
  }), "merchant-portal");

  MerchantPortalClient.interceptors.response.use(
      function (response) {
        return response;
      },
      function (error) {
        if (error?.response?.status === 401) {
          sessionStorage.clear();
          dispatch(resetResponseState());
          navigate("/", { replace: true });
        }

        return Promise.reject(error);
      }
  );

  return MerchantPortalClient;
}
export  const useMerchantPortalFormData = () => {
  const MerchantPortalClient = attachHttpRecorder(axios.create({
    baseURL: URL,
    timeout: 600000,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: sessionStorage.getItem("Token"),
    },
  }), "merchant-portal-form-data");

  return MerchantPortalClient;
}

export default useMerchantPortalAxios


